import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nc': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c139.8 0 248.4 107.9 248.4 248 0 147.2-118.5 248-248.4 248-134.5 0-247.6-110.8-247.6-248 0-132.9 104.7-248 247.6-248zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8v-38.2c-27.5-0.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-0.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23l-32.3 33.2c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z'
      }
    ]
  }
})
